

export interface DocumentCompressionConfigurationResult {
    raftCommandIndex: number;
}